// @ts-nocheck

import { Button, Input } from 'antd';
import React, { useState } from 'react';
import Field from '../../../../components/card/Field';
import Modal from '../../../../components/ant/Modal';






export default (props) => {
  const { visible } = props;

  const [declineReason, setDeclineReason] = useState(undefined);

  return (
    <Modal
      title="Причина отклонения"
      visible={visible}
      closable={false}
      maskClosable
      centered
      destroyOnHidden
      onCancel={props.handleCancel}
      footer={[
      <Button key="back" onClick={() => props.handleCancel()}>
          Отмена
        </Button>,
      <Button
        key="submit"
        type="primary"
        disabled={!declineReason}
        onClick={() => props.handleOk({ declineReason })}>

          Сохранить
        </Button>]
      }>

      <Field required label="Причина отклонения">
        <Input
          value={declineReason}
          onChange={(e) => setDeclineReason(e.target.value)} />

      </Field>
    </Modal>);

};
